export { LottieIcon, type LottieIconProps } from "./LottieIcon";
